import React, { useCallback, useState } from 'react';
import { FormTitle } from '../Register/FormTitle/FormTitle';
import { Form } from '../Register/Step/Form';
import { validatePassword } from '../validate';
import { ButtonContainer } from '../Button/Button';
import s from '../Authorization.module.css';
import { BackStepItem } from '../BackStep/BackStepItem';
import { Header } from '../Header/Header';
import { Contacts } from '../Contacts/Contacts';
import { PasswordInput } from '../PasswordInput/PasswordInput';
import { BackLoginLink } from '../BackLoginLink/BackLoginLink';

export const Reset = () => {
    const [errors, setErrors] = useState({
        password: null,
    });
    const [repeatInputError, setRepeatInputError] = useState({
        password: null,
    });

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [passwordChangedSuccess, setPasswordChangedSuccess] = useState(false);

    const sendResetPasswordRequest = useCallback(() => {
        const formData = new FormData();
        formData.append('reset_password_form[plainPassword][first]', password);
        formData.append('reset_password_form[plainPassword][second]', repeatPassword);
        formData.append('reset_password_form[_token]', window.csrf_token);

        fetch(window.location.href, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
            .then((response) => {
                if (response.status === 200) {
                    setPasswordChangedSuccess(true);
                }
            })
            .catch((err) => {
                window.console.error(`[Reset] ${err}`);
            });
    }, [password, repeatPassword]);

    const savePassword = useCallback(() => {
        if (password !== repeatPassword && password.length) {
            setRepeatInputError((prevState) => ({
                ...prevState,
                password: i18next.t('Reset.return.savePassword.password'),
            }));
        } else {
            setRepeatInputError((prevState) => ({ ...prevState, password: null }));
        }
        if (password === repeatPassword && errors.password === null) {
            sendResetPasswordRequest();
        } else if (errors.password !== null) {
            setErrors((prevState) => ({ ...prevState, password: validatePassword(password) }));
        }
    }, [errors.password, password, repeatPassword, sendResetPasswordRequest]);
    const isButtonDisabled = !password && !repeatPassword;

    const validateRepeatPassword = useCallback(
        (value) => {
            if (value.length === 0 && password.length === 0) {
                setErrors((prevState) => ({ ...prevState, password: validatePassword(password) }));
            }
        },
        [password]
    );

    return (
        <div className={s.authorizationBlock}>
            <Header type="mobile" />
            <div className={s.content}>
                <div className={s.mainImage} />
                <div className={s.formWrapper}>
                    <div className={s.formBlock}>
                        <Header type="desktop" />
                        {!passwordChangedSuccess && (
                            <div className={s.resetBlock}>
                                <FormTitle title={i18next.t('Reset.return.FormTitle.title')} subtitle="" />
                                <Form>
                                    <PasswordInput
                                        updatePassword={setPassword}
                                        validatePassword={validatePassword}
                                        setErrors={setErrors}
                                        errors={errors}
                                        label={i18next.t('Reset.return.PasswordInput.label')}
                                        id="password"
                                        tooltip
                                    />
                                    <PasswordInput
                                        updatePassword={setRepeatPassword}
                                        validatePassword={validateRepeatPassword}
                                        setErrors={() => {}}
                                        errors={repeatInputError}
                                        tooltip={false}
                                        label={i18next.t(
                                            'Reset.return.PasswordInput.repeatPassword.label'
                                        )}
                                        id="repeat-password"
                                    />
                                </Form>
                                <ButtonContainer
                                    textButton={i18next.t(
                                        'Reset.return.ButtonContainer.textButton'
                                    )}
                                    disable={isButtonDisabled}
                                    needShowLoader={false}
                                    onClick={savePassword}
                                />
                                <div className={s.stepBackMobile}>
                                    <a href={`${BASE_URL}/login`}>
                                        <BackStepItem text={i18next.t('Reset.return.backStep')} />
                                    </a>
                                </div>
                            </div>
                        )}
                        {passwordChangedSuccess && (
                            <div className={s.forgotPasswordBlock}>
                                <FormTitle
                                    title={i18next.t('Reset.return.successTitle')}
                                    subtitle={i18next.t('Reset.return.successSubtitle')}
                                />
                                <BackLoginLink />
                            </div>
                        )}
                    </div>
                    <Contacts />
                </div>
            </div>
        </div>
    );
};
